export default __webpack_public_path__ + "static/media/free-preview.11e8ef27.svg";